"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var DefaultNoContentMessage_1 = __importDefault(require("./DefaultNoContentMessage"));

var ExcelChartNoContentMessage_1 = __importDefault(require("./ExcelChartNoContentMessage"));

var ExcelNameRangeNoContentMessage_1 = __importDefault(require("./ExcelNameRangeNoContentMessage"));

var PPTNoContentMessage_1 = __importDefault(require("./PPTNoContentMessage"));

var PowerBiNoContentMessage_1 = __importDefault(require("./PowerBiNoContentMessage"));

require("./UnableToLoadContent.css");

var Icon_1 = __importDefault(require("../../common/Icon"));

var LibraryItemTypes_1 = require("@pwc/pwc-deals-web-common/build/src/constants/LibraryItemTypes");

var UnableToLoadContent = function (_a) {
  var type = _a.type,
      data = _a.data,
      errorCode = _a.errorCode,
      isPwcUser = _a.isPwcUser;

  var getContentItem = function () {
    var item;

    if (data) {
      var sharePointItemUrl = data.sharePointItemUrl,
          name_1 = data.name,
          Name = data.Name,
          worksheetName = data.worksheetName,
          chartName = data.chartName,
          groupName = data.groupName,
          slideNumber = data.slideNumber,
          SlideNumber = data.SlideNumber,
          GroupName = data.GroupName,
          ChartName = data.ChartName,
          SharePointItemUrl = data.SharePointItemUrl,
          WorksheetName = data.WorksheetName;
      var sourceUrl = sharePointItemUrl || SharePointItemUrl;
      var fileName = sourceUrl.split('/').pop();

      switch (type) {
        case LibraryItemTypes_1.LIBRARY_ITEM_TYPES.EXCEL_CELL_RANGE.value:
        case 'ExcelNamedRange':
          item = {
            tab: worksheetName || WorksheetName,
            section: name_1 || Name,
            sourceUrl: sourceUrl,
            fileName: fileName
          };
          break;

        case LibraryItemTypes_1.LIBRARY_ITEM_TYPES.EXCEL_CHART.value:
        case 'ExcelChart':
          item = {
            tab: worksheetName || WorksheetName,
            section: chartName || ChartName,
            sourceUrl: sourceUrl,
            fileName: fileName
          };
          break;

        case LibraryItemTypes_1.LIBRARY_ITEM_TYPES.POWER_POINT_GROUP.value:
          item = {
            tab: groupName || GroupName,
            section: slideNumber || SlideNumber,
            sourceUrl: sourceUrl,
            fileName: fileName
          };
          break;

        default:
          break;
      }
    }

    return item;
  };

  var getDefaultMessage = function () {
    return (0, jsx_runtime_1.jsx)(DefaultNoContentMessage_1.default, {
      isPwcUser: isPwcUser
    }, void 0);
  }; // todo -> will be used in the future
  // eslint-disable-next-line no-unused-vars


  var getDetailedMessage = function () {
    var item = getContentItem();
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
      children: [type === LibraryItemTypes_1.LIBRARY_ITEM_TYPES.EXCEL_CHART.value && (0, jsx_runtime_1.jsx)(ExcelChartNoContentMessage_1.default, {
        item: item,
        isPwcUser: isPwcUser,
        errorCode: errorCode
      }, void 0), type === LibraryItemTypes_1.LIBRARY_ITEM_TYPES.EXCEL_CELL_RANGE.value && (0, jsx_runtime_1.jsx)(ExcelNameRangeNoContentMessage_1.default, {
        item: item,
        isPwcUser: isPwcUser,
        errorCode: errorCode
      }, void 0), type === LibraryItemTypes_1.LIBRARY_ITEM_TYPES.POWER_BI_REPORT.value && (0, jsx_runtime_1.jsx)(PowerBiNoContentMessage_1.default, {
        item: item,
        isPwcUser: isPwcUser,
        errorCode: errorCode
      }, void 0), type === LibraryItemTypes_1.LIBRARY_ITEM_TYPES.POWER_POINT_GROUP.value && (0, jsx_runtime_1.jsx)(PPTNoContentMessage_1.default, {
        item: item,
        isPwcUser: isPwcUser,
        errorCode: errorCode
      }, void 0)]
    }, void 0);
  };

  return (0, jsx_runtime_1.jsxs)("div", __assign({
    "data-testid": "unable-to-load-content",
    className: "unable-to-load-data-container"
  }, {
    children: [(0, jsx_runtime_1.jsxs)("div", __assign({
      className: "unable-to-load-data-header"
    }, {
      children: [(0, jsx_runtime_1.jsx)(Icon_1.default, {
        name: "hyperlink-remove",
        className: "fill icon-orange-theme",
        width: "22",
        height: "22"
      }, void 0), (0, jsx_runtime_1.jsx)("div", __assign({
        className: "unable-to-load-data-header-title"
      }, {
        children: "Unable to load content"
      }), void 0)]
    }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({
      "data-testid": "unable-to-load-data-content",
      className: "unable-to-load-data-content"
    }, {
      children: getDefaultMessage()
    }), void 0)]
  }), void 0);
};

exports.default = UnableToLoadContent;